/**
 * 前端坐标转换（算法在 shared/coord-datum，前端副本 ./coordDatum/coordDatum.js）
 * 用于指挥页：WGS84 业务坐标 ↔ GCJ-02 国测局底图显示
 * 对外导出与行为保持不变：入参转 Number，非有限值或境外原样返回。
 */
import coordDatum from './coordDatum/coordDatum.js';

export function isInChina(lng, lat) {
  return coordDatum.isInChina(lng, lat);
}

/** WGS84 → GCJ-02 */
export function wgs84ToGcj02(lng, lat) {
  const lngN = Number(lng);
  const latN = Number(lat);
  if (!Number.isFinite(lngN) || !Number.isFinite(latN) || !isInChina(lngN, latN)) {
    return { lng: lngN, lat: latN };
  }
  return coordDatum.wgs84ToGcj02(lngN, latN);
}

/** GCJ-02 → WGS84（迭代；DEM 可用 2 轮） */
export function gcj02ToWgs84(lng, lat, iterations = 5) {
  const lngN = Number(lng);
  const latN = Number(lat);
  if (!Number.isFinite(lngN) || !Number.isFinite(latN) || !isInChina(lngN, latN)) {
    return { lng: lngN, lat: latN };
  }

  const rounds = Number.isFinite(Number(iterations)) ? Math.max(1, Number(iterations)) : 5;
  return coordDatum.gcj02ToWgs84(lngN, latN, rounds);
}